/* eslint-disable import/prefer-default-export */

export async function enrollAtCourse(course, plan = null) {
  const formData = new FormData();
  const userAuthToken = localStorage.getItem('arcux_auth_token');
  const planQuery = (plan) ? `?plan=${plan}` : '';

  const responseData = await fetch(`${process.env.VUE_APP_API}/courses/${course}/enrollments${planQuery}`, {
    method: 'POST',
    body: formData,
    headers: {
      Authorization: `Bearer ${userAuthToken}`,
    },
  })
    .then((res) => {
      if (res.status === 200 || res.status < 300) {
        return res.json();
      }

      return res.text().then((text) => { throw new Error(text); });
    })
    .then((response) => {
      if (response.status) {
        return response;
      }

      throw new Error(response.message);
    })
    .catch(async (err) => {
      throw err;
    });

  return responseData;
}
